interface CrmDetailLayoutProps {
  header?: React.ReactNode;
  /** Narrow left sidebar — col-span-1 */
  left?: React.ReactNode;
  /** Main content area — col-span-2 when both left and right exist, wider otherwise */
  center: React.ReactNode;
  /** Narrow right sidebar — col-span-1 */
  right?: React.ReactNode;
}

/**
 * Standard 4-column CRM detail layout.
 *
 * Columns (on lg+):
 *   left (1) | center (2) | right (1)
 *
 * Columns collapse gracefully when left/right are omitted.
 */
export function CrmDetailLayout({ header, left, center, right }: CrmDetailLayoutProps) {
  // 5-column grid: left=1, center=3, right=1 (both sides present)
  // When one side is absent the center expands to fill; no sides = full width.
  const centerSpan = left && right ? 'lg:col-span-3' : left || right ? 'lg:col-span-4' : 'lg:col-span-5';

  return (
    <div className="flex flex-col gap-4 p-4">
      {header}
      <div className="grid grid-cols-1 lg:grid-cols-5 gap-4">
        {left && <div className="lg:col-span-1 space-y-4">{left}</div>}
        <div className={centerSpan}>{center}</div>
        {right && <div className="lg:col-span-1 space-y-4">{right}</div>}
      </div>
    </div>
  );
}
